import { Field, FormikProps, useFormikContext } from 'formik'
import React from 'react'
import { FormSectionTwoColumns } from '../../../../../../../../components/forms/FormSectionTwoColumns'
import { CheckboxInput } from '../../../../../../../../components/inputs/CheckboxInput'
import { RichTextInput } from '../../../../../../../../components/inputs/RichTextInput/RichTextInput'
import { B3_FORM_INITIAL_VALUES } from '../constants'
import { InfoPopover } from '../../../../../../../../components/InfoPopover'

interface Props {}

export const B39ProtectionAgainstEnvironmentalFactors: React.FC<Props> = (props) => {
  const formik = useFormikContext() as FormikProps<typeof B3_FORM_INITIAL_VALUES>
  return (
    <>
      <FormSectionTwoColumns
        sectionKey="b3.protectionAgainstEnvironmentalFactors"
        title="B.3.9 Zásady ochrany stavby před negativními účinky vnějšího prostředí"
      >
        <div className="sm:col-span-6 mt-5">
          <Field
            name={`b3.protectionAgainstEnvironmentalFactors.floodMeasures.enabled`}
            component={CheckboxInput}
            label={formik.values.b3.protectionAgainstEnvironmentalFactors.floodMeasures.label}
          />
          {formik.values.b3.protectionAgainstEnvironmentalFactors.floodMeasures.enabled && (
            <>
              <div className="mt-3 pl-7">
                <Field
                  name={`b3.protectionAgainstEnvironmentalFactors.floodMeasures.description`}
                  component={RichTextInput}
                  aiHint={`Zásady ochrany stavby před negativními účinky vnějšího prostředí - ${formik.values.b3.protectionAgainstEnvironmentalFactors.floodMeasures.label}`}
                />
              </div>
            </>
          )}
        </div>
        <div className="sm:col-span-6 mt-5">
          <Field
            name={`b3.protectionAgainstEnvironmentalFactors.radonLeaks.enabled`}
            component={CheckboxInput}
            label={formik.values.b3.protectionAgainstEnvironmentalFactors.radonLeaks.label}
          />
          {formik.values.b3.protectionAgainstEnvironmentalFactors.radonLeaks.enabled && (
            <>
              <div className="mt-3 pl-7">
                <Field
                  name={`b3.protectionAgainstEnvironmentalFactors.radonLeaks.description`}
                  component={RichTextInput}
                  aiHint={`Zásady ochrany stavby před negativními účinky vnějšího prostředí - ${formik.values.b3.protectionAgainstEnvironmentalFactors.radonLeaks.label}`}
                />
              </div>
            </>
          )}
        </div>
        <div className="sm:col-span-6 mt-5">
          <Field
            name={`b3.protectionAgainstEnvironmentalFactors.protectionAgainstStrayCurrents.enabled`}
            component={CheckboxInput}
            label={
              formik.values.b3.protectionAgainstEnvironmentalFactors.protectionAgainstStrayCurrents
                .label
            }
          />
          {formik.values.b3.protectionAgainstEnvironmentalFactors.protectionAgainstStrayCurrents
            .enabled && (
            <>
              <div className="mt-3 pl-7">
                <Field
                  name={`b3.protectionAgainstEnvironmentalFactors.protectionAgainstStrayCurrents.description`}
                  component={RichTextInput}
                  aiHint={`Zásady ochrany stavby před negativními účinky vnějšího prostředí - ${formik.values.b3.protectionAgainstEnvironmentalFactors.protectionAgainstStrayCurrents.label}`}
                />
              </div>
            </>
          )}
        </div>
        <div className="sm:col-span-6 mt-5">
          <Field
            name={`b3.protectionAgainstEnvironmentalFactors.protectionAgainstSeismicity.enabled`}
            component={CheckboxInput}
            label={
              formik.values.b3.protectionAgainstEnvironmentalFactors.protectionAgainstSeismicity
                .label
            }
          />
          {formik.values.b3.protectionAgainstEnvironmentalFactors.protectionAgainstSeismicity
            .enabled && (
            <>
              <div className="mt-3 pl-7">
                <Field
                  name={`b3.protectionAgainstEnvironmentalFactors.protectionAgainstSeismicity.description`}
                  component={RichTextInput}
                  aiHint={`Zásady ochrany stavby před negativními účinky vnějšího prostředí - ${formik.values.b3.protectionAgainstEnvironmentalFactors.protectionAgainstSeismicity.label}`}
                />
              </div>
            </>
          )}
        </div>
        <div className="sm:col-span-6 mt-5">
          <div className="flex">
            <Field
              name={`b3.protectionAgainstEnvironmentalFactors.protectionAgainstGroundwater.enabled`}
              component={CheckboxInput}
              label={
                formik.values.b3.protectionAgainstEnvironmentalFactors.protectionAgainstGroundwater
                  .label
              }
            />
            <InfoPopover
              content={
                <div className="text-left">
                  <ol className="list-decimal pl-5 mt-3 font-bold">
                    <li>
                      Identifikace rizik
                      <ul className="list-disc pl-5">
                        <li className="mt-3">
                          Agresivní podzemní voda:
                          <div className="font-normal pl-5">
                            <p>
                              Geologický průzkum identifikoval přítomnost podzemní vody s chemickými
                              látkami (např. sírany, chloridy) s korozivním účinkem na stavební
                              materiály.
                            </p>
                            <p>
                              Agresivita vody byla klasifikována jako <b>nízká/střední/vysoká</b>.
                            </p>
                          </div>
                        </li>
                        <li className="mt-3">
                          Tlaková podzemní voda:
                          <div className="font-normal pl-5">
                            <p>
                              Na pozemku byla zjištěna přítomnost tlakové podzemní vody v důsledku
                              hydrogeologických podmínek (např. vysoká hladina podzemní vody,
                              jílovité podloží).
                            </p>
                            <p>
                              Hladina podzemní vody se nachází v úrovni/zvýšené úrovni vůči
                              základové konstrukci.
                            </p>
                          </div>
                        </li>
                      </ul>
                    </li>

                    <li className="mt-3">
                      Konstrukční opatření
                      <ul className="list-disc pl-5">
                        <li className="mt-3">
                          Základy:
                          <div className="font-normal pl-5">
                            <p className="font-bold mt-2">Vodotěsný beton:</p>
                            <p>
                              Základová konstrukce bude realizována z vodostavebního betonu s nízkou
                              propustností (např. třída C30/37 XC4).
                            </p>
                            <p>
                              Konstrukce bude opatřena přísadami, které zvyšují odolnost vůči
                              agresivním chemickým látkám.
                            </p>
                            <p className="font-bold mt-2">Zesílení základové desky:</p>
                            <p>
                              Tloušťka základové desky bude navržena tak, aby odolala tlakové vodě.
                            </p>
                            <p className="font-bold mt-2">Spáry a dilatace:</p>
                            <p>
                              Spáry mezi jednotlivými částmi základové konstrukce budou utěsněny
                              speciálními těsnicími páskami nebo bentonitovými těsněními.
                            </p>
                          </div>
                        </li>
                        <li className="mt-3">
                          Hydroizolace:
                          <div className="font-normal pl-5">
                            <p className="font-bold mt-2">Proti tlakové vodě:</p>
                            <p>
                              Bude použita vícevrstvá hydroizolace z materiálů odolných vůči tlakové
                              vodě (např. asfaltové pásy s vysokou mechanickou pevností, PVC fólie s
                              protitlakovou funkcí).
                            </p>
                            <p className="font-bold mt-2">Proti agresivní vodě:</p>
                            <p>
                              Hydroizolační vrstvy budou navrženy z chemicky odolných materiálů
                              (např. polyetylénové fólie, asfaltové pásy s příměsí kaučuku).
                            </p>
                            <p className="font-bold mt-2">Přechody a prostupy:</p>
                            <p>
                              Prostupy potrubí a kabelů budou utěsněny pomocí těsnicích manžet nebo
                              epoxidových pryskyřic.
                            </p>
                          </div>
                        </li>
                      </ul>
                    </li>

                    <li className="mt-3">
                      Odvodnění a tlaková ochrana
                      <ul className="list-disc pl-5">
                        <li className="mt-3">
                          Drenážní systém:
                          <div className="font-normal pl-5">
                            <p>
                              V okolí základů bude instalován drenážní systém s perforovanými
                              trubkami uloženými v drenážním štěrku.
                            </p>
                            <p>
                              Drenážní voda bude odváděna do retenční nádrže nebo kanalizačního
                              systému.
                            </p>
                          </div>
                        </li>
                        <li className="mt-3">
                          Snížení tlakové vody:
                          <div className="font-normal pl-5">
                            <p>
                              V oblastech s vysokým rizikem tlakové vody může být použito odvodnění
                              pomocí čerpacích systémů. V oblastech s vysokým rizikem tlakové vody
                              může být použito odvodnění pomocí čerpacích systémů.
                            </p>
                          </div>
                        </li>
                      </ul>
                    </li>

                    <li className="mt-3">
                      Materiálová ochrana
                      <ul className="list-disc pl-5">
                        <li className="mt-3">
                          Konstrukční materiály:
                          <div className="font-normal pl-5">
                            <p>
                              Konstrukce budou chráněny přísadami proti korozi, například
                              voděodolnými povrchovými úpravami nebo cementy odolnými proti síranům.
                            </p>
                          </div>
                        </li>
                        <li className="mt-3">
                          Kovové prvky:
                          <div className="font-normal pl-5">
                            <p>
                              Kovové části budou opatřeny antikorozními nátěry nebo galvanizací, aby
                              byly chráněny proti agresivní vodě.
                            </p>
                          </div>
                        </li>
                      </ul>
                    </li>

                    <li className="mt-3">
                      Kontrola a údržba
                      <ul className="list-disc pl-5 font-normal">
                        <li className="mt-3">
                          Po dokončení stavebních prací bude provedena tlaková zkouška hydroizolace
                          a kontrola účinnosti drenážního systému.
                        </li>
                        <li className="mt-3">
                          Pravidelná údržba drenážního systému a kontrola těsnosti izolací zajistí
                          dlouhodobou ochranu stavby.
                        </li>
                      </ul>
                    </li>
                  </ol>
                </div>
              }
            />
          </div>
          {formik.values.b3.protectionAgainstEnvironmentalFactors.protectionAgainstGroundwater
            .enabled && (
            <>
              <div className="mt-3 pl-7">
                <Field
                  name={`b3.protectionAgainstEnvironmentalFactors.protectionAgainstGroundwater.description`}
                  component={RichTextInput}
                  aiHint={`Zásady ochrany stavby před negativními účinky vnějšího prostředí - ${formik.values.b3.protectionAgainstEnvironmentalFactors.protectionAgainstGroundwater.label}`}
                />
              </div>
            </>
          )}
        </div>
        <div className="sm:col-span-6 mt-5">
          <Field
            name={`b3.protectionAgainstEnvironmentalFactors.protectionAgainstNoise.enabled`}
            component={CheckboxInput}
            label={
              formik.values.b3.protectionAgainstEnvironmentalFactors.protectionAgainstNoise.label
            }
          />
          {formik.values.b3.protectionAgainstEnvironmentalFactors.protectionAgainstNoise
            .enabled && (
            <>
              <div className="mt-3 pl-7">
                <Field
                  name={`b3.protectionAgainstEnvironmentalFactors.protectionAgainstNoise.description`}
                  component={RichTextInput}
                  aiHint={`Zásady ochrany stavby před negativními účinky vnějšího prostředí - ${formik.values.b3.protectionAgainstEnvironmentalFactors.protectionAgainstNoise.label}`}
                />
              </div>
            </>
          )}
        </div>
        <div className="sm:col-span-6 mt-5">
          <Field
            name={`b3.protectionAgainstEnvironmentalFactors.influenceOfUndermining.enabled`}
            component={CheckboxInput}
            label={
              formik.values.b3.protectionAgainstEnvironmentalFactors.influenceOfUndermining.label
            }
          />
          {formik.values.b3.protectionAgainstEnvironmentalFactors.influenceOfUndermining
            .enabled && (
            <>
              <div className="mt-3 pl-7">
                <Field
                  name={`b3.protectionAgainstEnvironmentalFactors.influenceOfUndermining.description`}
                  component={RichTextInput}
                  aiHint={`Zásady ochrany stavby před negativními účinky vnějšího prostředí - ${formik.values.b3.protectionAgainstEnvironmentalFactors.influenceOfUndermining.label}`}
                />
              </div>
            </>
          )}
        </div>
        <div className="sm:col-span-6 mt-5">
          <div className="flex">
            <Field
              name={`b3.protectionAgainstEnvironmentalFactors.methaneOccurrence.enabled`}
              component={CheckboxInput}
              label={formik.values.b3.protectionAgainstEnvironmentalFactors.methaneOccurrence.label}
            />
            <InfoPopover
              content={
                <div className="text-left">
                  <ol className="list-decimal pl-5 mt-3 font-bold">
                    <li>
                      Identifikace rizik
                      <ul className="list-disc pl-5 font-normal">
                        <li className="mt-3">
                          Geologický průzkum potvrdil přítomnost metanu ve vrstvě podloží:
                          <div className="font-bold pl-5 flex flex-col gap-2 mt-2">
                            <p>Koncentrace metanu je nízká (nízké riziko).</p>
                            <p>Koncentrace metanu je střední (střední riziko).</p>
                            <p>Koncentrace metanu je vysoká (vysoké riziko).</p>
                          </div>
                        </li>
                        <li className="mt-3">
                          Metan je přítomen v důsledku:
                          <div className="font-normal pl-5 flex flex-col gap-2 mt-2">
                            <p>
                              Přirozených geologických procesů (např. rozklad organického materiálu
                              v uhelných slojích nebo jílovitých vrstvách).
                            </p>
                            <p>Historické těžby uhlí nebo jiných horninových činností.</p>
                          </div>
                        </li>
                      </ul>
                    </li>

                    <li className="mt-3">
                      Návrh ochranných opatření
                      <ul className="list-disc pl-5 font-normal">
                        <li className="font-bold mt-3">
                          Preventivní hydroizolace a těsnění:
                          <div className="font-normal pl-5 flex flex-col gap-2 mt-2">
                            <p>
                              Základová konstrukce bude opatřena speciální těsnou membránou nebo
                              fólií, která zabraňuje průniku metanu do objektu.
                            </p>
                            <p>
                              Spoje membrány budou svařované nebo lepené, aby bylo zajištěno jejich
                              naprosté utěsnění.
                            </p>
                          </div>
                        </li>
                        <li className="font-bold mt-3">
                          Odvětrání podloží:
                          <div className="font-normal pl-5 flex flex-col gap-2 mt-2">
                            <p>
                              Pod základovou deskou bude instalován systém pasivního nebo aktivního
                              odvětrání:
                            </p>
                            <p>
                              <b>Pasivní systém:</b> Větrací vrstva (štěrkový zásyp nebo perforované
                              drenážní trubky) napojená na komínek odvádějící plyn nad úroveň
                              střechy.
                            </p>
                            <p>
                              <b>Aktivní systém:</b> Instalace odsávacího zařízení, které zajišťuje
                              kontrolované odsávání plynů z podloží.
                            </p>
                          </div>
                        </li>
                        <li className="font-bold mt-3">
                          Těsné provedení prostupů:
                          <div className="font-normal pl-5 flex flex-col gap-2 mt-2">
                            <p>
                              Veškeré prostupy potrubí, kabelů a dalších instalací budou utěsněny
                              pomocí speciálních manžet nebo tmelů, které zabraňují průniku metanu.
                            </p>
                          </div>
                        </li>
                        <li className="font-bold mt-3">
                          Ventilační opatření:
                          <div className="font-normal pl-5 flex flex-col gap-2 mt-2">
                            <p>
                              Prostor technických místností v kontaktu se základovou konstrukcí bude
                              vybaven větracími systémy, které zajistí dostatečnou výměnu vzduchu a
                              snížení koncentrace metanu.
                            </p>
                          </div>
                        </li>
                      </ul>
                    </li>

                    <li className="mt-3">
                      Monitoring koncentrace metanu
                      <ul className="list-disc pl-5 font-normal">
                        <li className="font-bold mt-3">
                          Během výstavby:
                          <div className="font-normal pl-5 flex flex-col gap-2 mt-2">
                            <p>
                              Pravidelné měření koncentrace metanu v podloží během zemních prací,
                              zejména při výkopech a zakládání stavby.
                            </p>
                          </div>
                        </li>
                        <li className="font-bold mt-3">
                          Po dokončení stavby:
                          <div className="font-normal pl-5 flex flex-col gap-2 mt-2">
                            <p>
                              Instalace detekčních čidel na bázi metanu v technických prostorách
                              nebo jiných rizikových zónách pro včasné varování v případě zvýšení
                              koncentrace.
                            </p>
                          </div>
                        </li>
                      </ul>
                    </li>

                    <li className="mt-3">
                      Hygienická a bezpečnostní opatření
                      <ul className="list-disc pl-5 font-normal">
                        <li className="font-bold mt-3">
                          Zajištění bezpečnosti:
                          <div className="font-normal pl-5 flex flex-col gap-2 mt-2">
                            <p>
                              Veškerá zařízení a systémy budou navržena tak, aby eliminovala riziko
                              vzniku výbušného prostředí (např. zařízení odolná vůči jiskření v
                              technických místnostech).
                            </p>
                          </div>
                        </li>
                        <li className="font-bold mt-3">
                          Nouzová opatření:
                          <div className="font-normal pl-5 flex flex-col gap-2 mt-2">
                            <p>
                              Vypracování plánu pro případ úniku metanu, zahrnující evakuaci a
                              postupy pro eliminaci rizika.
                            </p>
                          </div>
                        </li>
                      </ul>
                    </li>

                    <li className="mt-3">
                      Vliv na okolí
                      <ul className="list-disc pl-5 font-normal">
                        <li className="mt-3">
                          Veškerá opatření budou navržena tak, aby minimalizovala případný vliv
                          odvětrání metanu na okolní prostředí.
                        </li>
                        <li className="mt-3">
                          Při realizaci odvětrávacích systémů bude dbáno na to, aby odvod metanu
                          neovlivňoval sousední stavby nebo prostředí.
                        </li>
                      </ul>
                    </li>
                  </ol>
                </div>
              }
            />
          </div>
          {formik.values.b3.protectionAgainstEnvironmentalFactors.methaneOccurrence.enabled && (
            <>
              <div className="mt-3 pl-7">
                <Field
                  name={`b3.protectionAgainstEnvironmentalFactors.methaneOccurrence.description`}
                  component={RichTextInput}
                  aiHint={`Zásady ochrany stavby před negativními účinky vnějšího prostředí - ${formik.values.b3.protectionAgainstEnvironmentalFactors.methaneOccurrence.label}`}
                />
              </div>
            </>
          )}
        </div>
      </FormSectionTwoColumns>
    </>
  )
}
